export const AppDomain = process.env.VERCEL_URL
  ? process.env.VERCEL_URL
  : process.env.DEV_URL;